module.exports = __webpack_public_path__ + "img/dark_ic_new_stock.236ca49a.png";